"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntHelper = void 0;
var EntHelper = (function () {
    function EntHelper() {
    }
    Object.defineProperty(EntHelper, "IdFirstCharRegex", {
        get: function () {
            return /^[_A-Za-z]{1}$/;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EntHelper, "IdOtherCharsRegex", {
        get: function () {
            return /^[.\-_A-Za-z0-9]{1}$/;
        },
        enumerable: false,
        configurable: true
    });
    EntHelper.CamelCase = function (aString) {
        aString = aString.trim();
        var outAString = '';
        var words = aString.split(' ');
        for (var _i = 0, words_1 = words; _i < words_1.length; _i++) {
            var word = words_1[_i];
            if (word == ' ')
                continue;
            word = word.toLowerCase();
            outAString += word.substr(0, 1).toUpperCase() + word.substr(1);
        }
        return outAString;
    };
    EntHelper.GetIdFromName = function (aName) {
        aName = aName.trim();
        if (aName == '')
            return '_';
        else {
            var outAName = '';
            if (!this.IdFirstCharRegex.test(aName.substr(0, 1))) {
                outAName += '_';
            }
            for (var i = 0; i < aName.length; ++i) {
                var i_char = aName.substr(i, 1);
                if (this.IdOtherCharsRegex.test(i_char) || i_char == ' ')
                    outAName += i_char;
                else
                    outAName += '_';
            }
            return this.CamelCase(outAName);
        }
    };
    EntHelper.IsSingleGoto = function (goto) {
        return (typeof (goto) === 'string');
    };
    EntHelper.StrToStrArray = function (aStrOrStrArray) {
        if (typeof (aStrOrStrArray) == 'string')
            aStrOrStrArray = [aStrOrStrArray];
        return aStrOrStrArray;
    };
    return EntHelper;
}());
exports.EntHelper = EntHelper;
//# sourceMappingURL=EntitiesHelper.js.map